import { ILibraryQuestion as ICommonLibraryQuestion, SourceType as CommonSourceType } from '@aon/tws-common-ui-questions/build/lib/models';
import { DimensionType } from '@aon/tws-common-ui-questions/build/lib/models/enum';
import _ from 'lodash';
import Constants from '../constants';
import ContentConstants from '../contentConstants';
import { ICustomQuestion, QuestionType } from '../models';

const mapApiToLibraryQuestions = (questions: any[]) => {
	return questions.map((question: any) => {
		const sourceType =
			question.ownerId === Constants.KINCENTRIC_OWNER_ID ? CommonSourceType.KincentricLibrary : CommonSourceType.ClientLibrary;
		let libraryQuestion: ICommonLibraryQuestion = {
			alternateVersions: 0,
			attributeName: question.isDemographic ? question.attributeName : undefined,
			benchmarkIds: [],
			code: question.code,
			dimensionNames: question.dimensions ? question.dimensions.map((d: any) => d.name) : [],
			isDemographic: question.isDemographic,
			languageCount: question.languageCount,
			languages: question.languages,
			ownerId: question.ownerId,
			publicationStatus: question.publicationStatus,
			parentQuestionId: question.parentQuestionId,
			questionId: question.questionId,
			questionType: question.questionType,
			questionVariationId: question.defaultQuestionVariationId,
			showVariations: false,
			responseOptionGroup: getResponseOptionGroup(question),
			responseOptionGroupId: question.responseOptionGroupId,
			responseOptions: getResponseOptions(question, 'desc'),
			scoredDimensionNames: question.dimensions
				? question.dimensions.filter((di: any) => di.isScored && di.dimensionType === DimensionType.Dimension).map((d: any) => d.name)
				: [],
			sourceType,
			text: question.defaultText,
		};
		if (question.variations) {
			const nonDefaultVariations = _.filter(question.variations, (v) => !v.isDefault);
			libraryQuestion = {
				...libraryQuestion,
				alternateVersions: nonDefaultVariations.length,
				questionVariations: nonDefaultVariations.map((v: any) => ({
					questionVariationId: v.questionVariationId,
					text: v.defaultText,
					code: v.code,
					isDefault: v.isDefault,
					languageCount: v.translations ? v.translations.length : 0,
					languages: v.translations ? v.translations.map((t: any) => t.text) : [],
					publicationStatus: v.publicationStatusId,
					sourceType: v.ownerId === Constants.KINCENTRIC_OWNER_ID ? CommonSourceType.KincentricLibrary : CommonSourceType.ClientLibrary,
				})),
			};
		}
		return libraryQuestion;
	});
};

const mapCustomQuestionsToLibraryQuestions = (customQuestions: ICustomQuestion[]) => {
	return customQuestions.map((cq: ICustomQuestion) => {
		const libraryQuestion: ICommonLibraryQuestion = {
			showVariations: false,
			questionVariations: [],
			languageCount: cq.languages && cq.languages.length,
			benchmarkIds: [],
			questionId: cq.questionId,
			text: cq.text,
			code: cq.code,
			questionType: cq.questionType,
			languages: cq.languages,
			responseOptionGroup: getResponseOptionGroup(cq),
			responseOptions: getResponseOptions(cq, 'asc'),
			sourceType: CommonSourceType.Custom,
			alternateVersions: 0,
			questionVariationId: 0,
			scoredDimensionNames: [],
			isDemographic: cq.isDemographic,
		};
		return libraryQuestion;
	});
};

export const LibraryQuestionMapperUtility = {
	mapApiToLibraryQuestions,
	mapCustomQuestionsToLibraryQuestions,
};

const getResponseOptionGroup = (question: any) => {
	switch (question.questionType) {
		case QuestionType.OpenEnded:
			return ContentConstants.RESPONSE_OPTION_GROUP_OPEN_ENDED;
		case QuestionType.TextBox:
			return ContentConstants.RESPONSE_OPTION_GROUP_TEXT_BOX;
		default:
			// ICustomQuestion uses just a string where other question interfaces can have a whole object.
			if (typeof question.responseOptionGroup === 'string') {
				return question.responseOptionGroup;
			} else if (question.responseOptionGroup) {
				return question.responseOptionGroup.name;
			}
			return '';
	}
};

const getResponseOptions = (question: any, order: 'asc' | 'desc') => {
	// ICustomQuestion does not parent response options under responseOptionGroups
	if (question.responseOptions) {
		return _.orderBy(question.responseOptions, ['displayOrder'], [order]).map((ro: any, index) => ({
			displayOrder: index + 1,
			displayText: ro.displayText,
		}));
	}
	// Other question interfaces parent collections of response options under the responseOptionGroup
	if (question.responseOptionGroup) {
		if (question.responseOptionGroup.responseOptions) {
			return _.orderBy(question.responseOptionGroup.responseOptions, ['displayOrder'], [order]).map((ro: any, index) => ({
				displayOrder: index + 1,
				displayText: ro.name,
			}));
		}
	}

	return [];
};
